import adserver from 'services/adserver';
import {
  useMutation,
  useQueryClient,
  UseMutationResult,
} from '@tanstack/react-query';
import { proposalsKeys } from './proposals.keys';
import { Proposal } from './proposals.types';

const updateProposalId = async (data: {
  customId: string;
  id: number;
}): Promise<Proposal> => {
  const { data: response } = await adserver({
    url: `/proposal/${data.id}/customId`,
    method: 'PATCH',
    data: { value: data.customId },
    headers: {},
  });
  return response;
};

export const useUpdateProposalId = (): UseMutationResult<
  Proposal,
  unknown,
  { customId: string; id: number },
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: updateProposalId,
    onSuccess: data => {
      queryClient.setQueryData(proposalsKeys.detail(data.id), data);
      queryClient.invalidateQueries({
        queryKey: proposalsKeys.lists(),
      });
      queryClient.invalidateQueries({
        queryKey: proposalsKeys.detail(data.id),
      });
    },
  });
};
